var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"img-responsive",attrs:{"src":_vm.profileImageSrc,"alt":`${_vm.username}'s avatar`,"title":"Player avatar","loading":"lazy","width":"120","height":"120"}})
}
var staticRenderFns = []

export { render, staticRenderFns }